import { useCallback } from 'react';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';

export const useLogClickReportPriceAbusing = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();

  return useCallback(() => {
    logGoodsAnalytics({
      name: 'CLICK_REPORT_PRICE_ABUSING',
    });
  }, [logGoodsAnalytics]);
};